import { render } from "./StartGameTeam.vue?vue&type=template&id=230e01a0"
import script from "./StartGameTeam.vue?vue&type=script&lang=js"
export * from "./StartGameTeam.vue?vue&type=script&lang=js"

import "./StartGameTeam.vue?vue&type=style&index=0&id=230e01a0&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__